/* eslint-disable no-nested-ternary */
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from '../styles.module.scss';

const TotalPriceHeader = ({
  currency,
  translationKey,
  isQuantityMergeEnabled = true,
  taxDisclaimerMessage
}) => {
  const currencyLabel = currency ? `(${currency})` : '';
  const [t] = useTranslation();

  return (
    <div className={`d-block my-0 ${styles['table-header-text']}`}>
      <span>
        {t(translationKey)}
        <span
          className={`ps-1 u-color--DarkGray ${styles['table-header__sub-header-text']}`}
        >
          {currencyLabel}
        </span>
      </span>

      {!!taxDisclaimerMessage && (
        <span
          className={`d-block my-0 text-transform-none u-fs--12 ${styles['table-header__sub-header-text']}`}
        >
          {taxDisclaimerMessage}
          {!isQuantityMergeEnabled ? (
            <sup>&dagger;&dagger;</sup>
          ) : (
            <sup>&dagger;</sup>
          )}
        </span>
      )}
    </div>
  );
};

TotalPriceHeader.propTypes = {
  currency: PropTypes.string,
  translationKey: PropTypes.string,
  isQuantityMergeEnabled: PropTypes.bool,
  taxDisclaimerMessage: PropTypes.string
};

export default TotalPriceHeader;
